// @flow
import React from 'react';

import { withTranslation } from 'react-i18next';
import { withStyles, withTheme } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import makeComponentTrashable from 'trashable-react';
import { TextField, Select, MenuItem, IconButton, InputLabel, FormControl } from '@material-ui/core';
import Check from '@material-ui/icons/Check';
import Edit from '@material-ui/icons/Edit';
import Cancel from '@material-ui/icons/Cancel';

import { sendUpdateTitleMessage } from '../../utils/ws-v1';
import { getSocketIfExist } from '../../utils/getSocket';
import { getFirestore } from '../../firebase';

const styles = {
  badge: {
    marginLeft: '3px',
    marginRight: '3px',
    paddingLeft: '6px',
    borderRadius: '3px',
    paddingRight: '6px',
    paddingTop: '1px',
    paddingBottom: '2px',
    backgroundColor: 'steelblue',
    display: 'flex',
    flexDirection: 'row',
  },
};

type State = {
  title?: string,
  roLink?: string,
  edit: boolean,
  links: Array<Object>,
};

type Props = {
  title: string,
  roLink: string,
  classes: Object,
};

class UpdateConvoMeta extends React.Component<Props, State> {
  ref;

  constructor(props) {
    super(props);
    this.state = {
      title: undefined,
      roLink: undefined,
      edit: false,
      links: [],
    };
  }

  async componentDidMount() {
    (await getFirestore()).collection('links').onSnapshot(d => {
      const links = [];
      d.forEach(l => links.push(l.data()));
      this.setState({ links });
    });
  }

  handleTitleChange(e) {
    this.setState({ title: e.target.value });
  }

  handleROLinkChange(e) {
    this.setState({ roLink: e.target.value });
  }

  update() {
    const { title, roLink } = this.state;
    const { roLink: defaultRoLink, title: defaultTitle } = this.props;
    const ws = getSocketIfExist();
    if (!ws) return;
    sendUpdateTitleMessage(ws, {
      title: title === undefined ? defaultTitle : title,
      roLink: roLink === undefined ? defaultRoLink : roLink,
    });
    this.setState({ title: undefined, roLink: undefined, edit: false });
  }

  render() {
    const { roLink: defaultRoLink, title: defaultTitle, classes } = this.props;
    const { edit, title, roLink, links } = this.state;
    return (
      <>
        {!edit && (
          <>
            <div className={`edit-container ${classes.badge}`}>
              <div>
                <span>{defaultTitle || 'no title'}</span>
                <br style={{ display: 'block', margin: '-3px 0' }} />
                <span
                  style={{
                    fontSize: 12,
                    opacity: 0.8,
                  }}
                >
                  {defaultRoLink ? (
                    <a
                      style={{
                        textDecoration: 'none',
                        color: 'inherit',
                      }}
                      href={defaultRoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {defaultRoLink}
                    </a>
                  ) : (
                    <div>no ro link</div>
                  )}
                </span>
              </div>
              <div
                style={{
                  width: 20,
                  minWidth: 20,
                }}
              >
                {/* eslint-disable-next-line */}
                <div
                  className="edit"
                  onClick={() => this.setState({ edit: true })}
                  style={{ cursor: 'pointer' }}
                  role="heading"
                  aria-level="1"
                >
                  <Edit
                    style={{
                      width: 15,
                      height: 15,
                      marginTop: 10,
                      marginLeft: 3,
                      color: 'white',
                      opacity: 0.9,
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {edit && (
          <form
            onSubmit={() => {
              this.update();
            }}
            style={{
              background: 'rgba(30,30,30,0.5)',
              borderRadius: 5,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 600,
            }}
          >
            <TextField
              defaultValue={title === undefined ? defaultTitle : title}
              label="title"
              onChange={e => this.handleTitleChange(e)}
              autoFocus
              id="title"
              style={{ maxWidth: 300, marginTop: 5 }}
              margin="normal"
              onKeyDown={ev => {
                if (['Enter'].includes(ev.key)) {
                  this.update();
                }
              }}
            />
            <FormControl
              style={{
                maxWidth: 300,
                minWidth: 100,
                marginTop: 5,
                marginLeft: 10,
              }}
            >
              <InputLabel shrink htmlFor="age-label-placeholder">
                Readonly Link
              </InputLabel>
              <Select
                value={roLink === undefined ? defaultRoLink : roLink}
                onChange={e => this.handleROLinkChange(e)}
                inputProps={{
                  name: 'Readonly link',
                  id: 'ro-link',
                }}
              >
                <MenuItem key="none" value="">
                  None
                </MenuItem>
                {links.map(l => (
                  <MenuItem key={l.url} value={l.url}>
                    {l.url}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <IconButton style={{ marginTop: 10 }} type="submit">
              <Check />
            </IconButton>
            <IconButton
              style={{ marginTop: 10, color: 'lightgrey' }}
              onClick={() => {
                this.setState({ edit: false });
              }}
            >
              <Cancel />
            </IconButton>
          </form>
        )}
      </>
    );
  }
}

// $FlowFixMe
export default withRouter(withStyles(styles)(withTheme(makeComponentTrashable(withTranslation()(UpdateConvoMeta)))));
